import { render, staticRenderFns } from "./LParentView.vue?vue&type=template&id=738437a2"
import script from "./LParentView.vue?vue&type=script&lang=js"
export * from "./LParentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports